import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Table } from "@pentabd/ui";

import { InputDateControllerVertical, SearchBox } from "@components";
import { DistributionTableColumn } from "./DistributionTableColumn";

import { useDistributionList } from "@hooks/inventory/stock/distribution/useDistributionList";
import { useLanguage } from "@hooks/useLanguage";

import { TablePagination } from "@helpers/tablePagination";

import { DistributionResponseType } from "@type/inventory/stock/distribution";

export default function DistributionListTable() {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const { control } = useForm();

  const { handleQuery, distributionState } = useDistributionList();
  const { getData } = distributionState;

  const { data, pagination } = getData || ({} as DistributionResponseType);

  return (
    <Table
      header={{
        title: t("INVENTORY_STOCK.DISTRIBUTION.TABLE.HEADER"),
        badge: {
          label: `${pagination?.total || 0}`,
          size: "sm",
          type: "primary",
        },
      }}
      headerExtension={{
        leftComponents: [
          <div className="d-flex gap-10 flex-wrap w-100">
            <InputDateControllerVertical
              control={control}
              label="INVENTORY_STOCK.DISTRIBUTION.TABLE.START_DATE"
              name="startDate"
              onSelectDate={(date) => handleQuery("startDate", date)}
              cols={4}
              withoutLabel
              portal
            />
            <InputDateControllerVertical
              control={control}
              label="INVENTORY_STOCK.DISTRIBUTION.TABLE.END_DATE"
              name="endDate"
              onSelectDate={(date) => handleQuery("endDate", date)}
              cols={4}
              withoutLabel
              portal
            />
          </div>,
        ],
        rightComponents: [
          <SearchBox
            key="search"
            control={control}
            placeholder={t("INVENTORY_STOCK.DISTRIBUTION.TABLE.SEARCH")}
            handleQuery={handleQuery}
          />,
        ],
      }}
      columns={DistributionTableColumn(t, language)}
      rows={data || []}
      pagination={TablePagination(pagination, handleQuery)}
    />
  );
}
